export default {
  state: {
    navData: [],
  },
  mutations: {
    emptyNav(state) {
      state.navData = [];
    },
    setNav(state, nav) {
      state.navData = nav;
    },
  },
  actions: {},

  getters: {
    getNav: (state) => {
      return state.navData;
    },
  },
};
